import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const ThemePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e0f7fc',
      100: '#b3e6f6',
      200: '#80d4f0',
      300: '#4dc3ea',
      400: '#26b5e3',
      500: '#0099cb', // main
      600: '#0088b5',
      700: '#00739b',
      800: '#005f80',
      900: '#004f6b',
      950: '#003549',
    },
  },
});
